export default "__VITE_ASSET__KxSwQQTN__"